import { EN, ZH, ZH_HK } from '@/locales';

export const columnMapInfo = {
	[ZH]: {
		'公司全称': 'fullName',
		'股票简称': 'name',
		'股票代码': 'code',
		'法定代表人': 'legalRep',
		'上市交易所': 'marketSourceName',
		'电子邮箱': 'email',
		'联系方式': 'phone',
		'联系地址': 'addressList[0].address'
	},
	[EN]: {
		'Company Limited': 'fullNameEn',
		'Stock Name': 'nameEn',
		'Stock Code': 'code',
		'Body Corporate': 'legalRep',
		'Bourse': 'marketSourceNameEn',
		'Email': 'emailEn',
		'Phone': 'phoneEn',
		'Address': 'addressEnList[0].address'
	},
	[ZH_HK]: {
		'公司全稱': 'fullNameZhCht',
		'股票簡稱': 'nameZhCht',
		'股票代碼': 'code',
		'法定代表人': 'legalRep',
		'上市交易所': 'marketSourceNameZhCht',
		'電子郵件': 'emailZhCht',
		'聯繫方式': 'phoneZhCht',
		'聯繫地址': 'addressZhChtList[0].address'
	}
};
